import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { LeftPanel } from "./Login";
import "../styles/auth.css";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [pwdVisible, setPwdVisible] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pwd.length < 8) {
      setError("Le mot de passe doit contenir au moins 8 caractères.");
      return;
    }
    if (pwd !== pwd2) {
      setError("Les deux mots de passe ne correspondent pas.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pwd });
      setDone(true);
      setTimeout(() => navigate("/login"), 3000);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-layout" data-testid="reset-password-page">
      <LeftPanel />
      <div className="auth-right">
        <div className="auth-form-wrap">
          {done ? (
            <div className="auth-success-screen">
              <div className="auth-success-icon">🔒</div>
              <div className="auth-success-title">Mot de passe modifié</div>
              <p className="auth-success-sub">
                Votre mot de passe a bien été réinitialisé. Vous allez être
                redirigé vers la page de connexion…
              </p>
              <p className="auth-bottom-link">
                <Link to="/login">Se connecter maintenant →</Link>
              </p>
            </div>
          ) : !token ? (
            <div className="auth-success-screen">
              <div className="auth-success-icon">⚠️</div>
              <div className="auth-success-title">Lien invalide</div>
              <p className="auth-success-sub">
                Ce lien de réinitialisation est incomplet. Repartez de la page
                « Mot de passe oublié » pour en recevoir un nouveau.
              </p>
              <p className="auth-bottom-link">
                <Link to="/forgot-password">Demander un nouveau lien →</Link>
              </p>
            </div>
          ) : (
            <>
              <h2 className="auth-title">Nouveau mot de passe</h2>
              <p className="auth-subtitle">
                Choisissez un nouveau mot de passe pour votre compte
                (8 caractères minimum).
              </p>

              {error && (
                <div className="auth-alert auth-alert-error">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                    <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
                  </svg>
                  {error}
                </div>
              )}

              <form onSubmit={submit}>
                <div className="auth-field-group">
                  <label className="auth-field-label" htmlFor="new-pwd">Nouveau mot de passe</label>
                  <div className="auth-field-wrap">
                    <input type={pwdVisible ? "text" : "password"} id="new-pwd" placeholder="8 caractères minimum"
                      autoComplete="new-password" required minLength={8}
                      value={pwd} onChange={e => setPwd(e.target.value)} data-testid="reset-password" />
                    <div className="auth-field-icon">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
                        <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                      </svg>
                    </div>
                    <button type="button" className="auth-pwd-toggle" onClick={() => setPwdVisible(v => !v)}>
                      {pwdVisible
                        ? <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                        : <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7z"/><circle cx="12" cy="12" r="3"/></svg>
                      }
                    </button>
                  </div>
                </div>

                <div className="auth-field-group">
                  <label className="auth-field-label" htmlFor="new-pwd2">Confirmez le mot de passe</label>
                  <div className="auth-field-wrap">
                    <input type={pwdVisible ? "text" : "password"} id="new-pwd2" placeholder="Répétez votre mot de passe"
                      autoComplete="new-password" required minLength={8}
                      value={pwd2} onChange={e => setPwd2(e.target.value)} data-testid="reset-password-confirm" />
                    <div className="auth-field-icon">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
                        <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                      </svg>
                    </div>
                  </div>
                </div>

                <button type="submit" className="auth-btn-submit" disabled={loading} data-testid="reset-submit">
                  {loading ? (
                    <><span className="auth-spinner"/><span>Réinitialisation…</span></>
                  ) : (
                    <span>Réinitialiser le mot de passe</span>
                  )}
                </button>
              </form>

              <p className="auth-bottom-link">
                <Link to="/login">← Retour à la connexion</Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
